// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"348":"bundle.standardizedaudiocontext","475":"amy3DLazy","813":"npm.three"}[chunkId] || chunkId) + "." + {"176":"4cf713c6","348":"4bd0b04e","475":"493bb604","813":"e4b2ffd6"}[chunkId] + ".chunk.js";
};